/**
 * The vehicle types ("Doppeldecker", "Gelenkbus 18m", …) are the children of this Geotab group;
 * in the customer's tree it sits below "Attribute". Change the names here, not in the page logic.
 */
export const VEHICLE_TYPE_GROUP_NAME = "Typ";

/** Parent of the type group, used when a database has more than one group named "Typ". */
export const VEHICLE_TYPE_PARENT_NAME = "Attribute";
